import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router';
import { Card, Icon, Button } from 'antd';
import PropTypes from 'prop-types';

import icones from '../../images/avis';
import { configuracioScrollIntoView } from '../../constants';
import { selectorDataActual } from '../../selectors/selector_data_actual';
import { convertirTextAMomentLocal } from '../../commons/gestioDates';

import { textQuanNoHiHaDada } from '../../constants';

import { avisVisualitzacioSeleccionarAvis, omplirFormulariAmbUnAvis, eliminarAvis } from '../../actions/avis';
import { rutaIntroduirAvisos } from '../../routes/routeConstants';
import errorBoundaryWrapper from '../commons/errorBoundaryWrapper';
import seguretatWrapper from '../seguretat/seguretatWrapper';
import { esPotEditarEliminarAvis } from '../../commons/callbacksSeguretat';
import ImatgeAmbControlError from '../commons/imatgeAmbControlError';

const renderNomValor = (index, nomCamp, valor, unitat = null) => {
    return (
        <div key={index} className='avis-detall-label-valors salt-de-linia'>
            <span>{nomCamp}: </span>{valor} {unitat || null}
        </div>
    );
};

class AvisDetall extends Component {

    componentDidMount() {
        if (this.avisDetall.scrollIntoView) {
            this.avisDetall.scrollIntoView(configuracioScrollIntoView);
        }
    }

    componentDidUpdate() {
        if (this.avisDetall.scrollIntoView) {
            this.avisDetall.scrollIntoView(configuracioScrollIntoView);
        }
    }

    onClickBotoEditar() {
        const avis = this.props.avis;
        this.props.omplirFormulariAmbUnAvis(avis);
    }

    onClickBotoEliminar() {
        const idAvis = this.props.avis.id;
        this.props.eliminarAvis(idAvis);
    }

    tancarDetall() {
        this.props.avisVisualitzacioSeleccionarAvis(null);
    }

    renderExtra() {
        return <Icon className="avis-detall-icone-tancar" type="close" style={{ fontSize: 22 }} onClick={() => this.tancarDetall()} />;
    }

    renderValorTipusFoto(index, camp, valor) {
        const urlFotoAmbParametrePerEvitarCache = `${valor}?${Date.now()}`;
        return (
            <div key={index} className='avis-detall-label-valors'>
                <span>{camp.nom}: </span>
                <ImatgeAmbControlError url={urlFotoAmbParametrePerEvitarCache} classNameImg={'imatge-foto'}/>
            </div>
        );
    }

    renderValorTipusLlista(index, camp, valor) {
        //s'ha de recuperar el nom del valor de la llista de valorsPossibles
        const valorDeLlista = camp.valorsPossibles.find(possibleValor => possibleValor.id === Number(valor));
        return renderNomValor(index, camp.nom, valorDeLlista ? valorDeLlista.nom : null);
    }

    renderValorTipusNumeric(index, camp, valor) {
        return renderNomValor(index, camp.nom, valor, camp.unitat);
    }

    renderValorTipusTextLliure(index, camp, valor) {
        return renderNomValor(index, camp.nom, valor);
    }

    renderValors(avis) {
        const meteors = this.props.meteors;

        const mostrarValorSegonsTipus = {
            'TL': this.renderValorTipusTextLliure,
            'NM': this.renderValorTipusNumeric,
            'LL': this.renderValorTipusLlista,
            'FT': this.renderValorTipusFoto
        };

        return avis.valors.map((elementValor, index) => {
            const meteor = meteors[avis.idMeteor];

            const idCamp = Object.keys(elementValor)[0];
            const camp = meteor.camps[idCamp];

            const valor = elementValor[idCamp];

            return mostrarValorSegonsTipus[camp.tipus](index, camp, valor);
        });
    }

    renderTitle(data, idMeteor) {
        const src = icones[idMeteor];
        return <div>{data} <img alt={src} className="avis-detall-titol-icona" src={src}></img></div>;
    }

    render() {

        const { dataActualText, avis, meteors, estaPeticioEliminarAvisEnCurs } = this.props;

        const idVigilant = avis.vigilant.id;
        const nomVigilant = avis.vigilant.nom;
        const cognom1Vigilant = avis.vigilant.cognom1;
        const cognom2Vigilant = avis.vigilant.cognom2;

        const nomMunicipi = avis.municipi.nom;
        const nomMeteor = meteors[avis.idMeteor].nom;

        const dataAvisMoment = convertirTextAMomentLocal(avis.data);
        const dataAvisText = dataAvisMoment.format('DD-MM-YYYY HH:mm [h]');

        const dataActualMoment = convertirTextAMomentLocal(dataActualText);

        const esPotRenderitzarComponent = esPotEditarEliminarAvis(dataActualMoment, dataAvisMoment, idVigilant);
        const LinkAmbSeguretat = seguretatWrapper(Link, esPotRenderitzarComponent);
        const ButtonAmbSeguretat = seguretatWrapper(Button, esPotRenderitzarComponent);

        return (
            <div ref={ref => this.avisDetall = ref}>
                <Card title={this.renderTitle(dataAvisText, avis.idMeteor)} size="small" className="camp scrollable avis-detall" extra={this.renderExtra()}>
                    <Card bordered={false}>
                        <div className="avis-detall-element avis-detall-label">
                            <span>Vigilant:</span>{nomVigilant} {cognom1Vigilant} {cognom2Vigilant}
                        </div>

                        <div className="avis-detall-element avis-detall-label">
                            <span>Altitud:</span>{(avis.altitud || avis.altitud === 0) ? avis.altitud + ' m' : textQuanNoHiHaDada}
                        </div>

                        <div className="avis-detall-element avis-detall-label">
                            <span>Comarca:</span>{avis.comarca.nom}
                        </div>

                        <div className="avis-detall-element avis-detall-label">
                            <span>Municipi:</span>{nomMunicipi}
                        </div>
                    </Card>
                    <Card bordered={false} className='avis-detall-container-meteor'>
                        <div className="avis-detall-label-valors">
                            <span>Meteor:</span>{nomMeteor}
                        </div>

                        {this.renderValors(avis)}
                    </Card>
                    <div className='avis-detall-botons-editar-eliminar'>
                        <LinkAmbSeguretat to={rutaIntroduirAvisos}>
                            <Button
                                className='avis-detall-boto-editar'
                                icon='edit'
                                onClick={() => this.onClickBotoEditar()}>
                                Editar
                            </Button>
                        </LinkAmbSeguretat>
                        <ButtonAmbSeguretat
                            className='avis-detall-boto-eliminar'
                            icon='delete'
                            loading={estaPeticioEliminarAvisEnCurs}
                            onClick={() => this.onClickBotoEliminar()}>
                            Eliminar
                        </ButtonAmbSeguretat>
                    </div>
                </Card>
            </div>
        );
    }
}

AvisDetall.propTypes = {
    dataActualText: PropTypes.string,
    avis: PropTypes.object.isRequired,
    meteors: PropTypes.object.isRequired,
    estaPeticioEliminarAvisEnCurs: PropTypes.bool,
    avisVisualitzacioSeleccionarAvis: PropTypes.func,
    omplirFormulariAmbUnAvis: PropTypes.func,
    eliminarAvis: PropTypes.func
};

const mapStateToProps = (state) => {
    return {
        dataActualText: selectorDataActual(state),
        meteors: state.avis.meteors,
        estaPeticioEliminarAvisEnCurs: state.avis.visualitzacio.avisos.peticioEliminarEnCurs
    };
};

export default errorBoundaryWrapper(
    connect(mapStateToProps, { avisVisualitzacioSeleccionarAvis, omplirFormulariAmbUnAvis, eliminarAvis })(AvisDetall));


// WEBPACK FOOTER //
// ./src/components/avis/avisDetall.js